<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="analyze-page" v-else-if="loaded" > 
        
        <div class="row no-gutters mb-3 " >
            
            <div class="col-12 col-md-auto border-bottom-gray" >
        
                <ul class="horizontal-menu font-size-16 font-weight-bold col-12 border-none" >

                    <li class="mr-5" >
                        <h1 class="h2 font-900" > Funnels </h1>   
                    </li>
                    
                    <li>
                        <a @click="view = 'list'" :class="[{'router-link-exact-active router-link-active': view == 'list'}]" > List view </a>
                    </li>

                    <li>
                        <a @click="view = 'chart'" :class="[{'router-link-exact-active router-link-active': view == 'chart'}]" > Chart view </a>
                    </li>

                </ul>    

            </div>
            
            <div class="col text-md-right border-bottom-gray" style=""  >    
            </div>
            
            <div class="col-12 col-md-auto border-bottom-gray text-md-right " >
                
                <span class="h3 font-900" style="line-height: 58px; margin-rigth: 15px" > Select dates:  </span>

                <date-picker v-model="period" range valueType="format" :format="formatDate" confirm class="datepicker ml-2" clear-button-icon="false" :shortcuts="shortcuts" placeholder="Select dates:" ></date-picker>
                
                <!--
                Refresh: <a @click="refresh_chart" class="ml-1"  > <font-awesome-icon icon="sync" /> </a>
                -->
                <a @click="getData" class="btn btn-primary" > Request </a>
                <a @click="configureFunnels" class="btn btn-secondary" > Configure </a>
                
            </div>
 
        </div>
        
        <div class="row no-gutters mb-3 mt-4" >
            
            <div class="col-12 mt-4" v-if="funnels.length == 0" >
                
                <b-alert show variant="secondary" class="w-100 mb-3 text-center" >
                            
                    You don't have any funnels. <a @click="configureFunnels" style="text-decoration: underline" > Go to funnels </a> and create one

                </b-alert>  
                
            </div>
            
            <div class="col-12 " v-else-if="funnels.length > 0 && view == 'chart'" >
                
                <div class="row" >

                    <div class="col-12 col-md-6 mt-3 mb-3" v-for="(funnel, index) in funnels" >
                        
                        <h1 class="h3 font-900 mb-4" > {{ funnel.name }} </h1>
                        
                        <div class="col-12" v-if="!funnel.loaded" style="height: 270px" >
                            <spinner ></spinner>
                        </div>
                        <line-chart v-else-if="funnel.loaded" :chart-data="funnel.chartData" :labels="funnel.chartData[0].columns" :width="450" :height="270" symbol=" " :chartDataName="funnel.name" ></line-chart>
                        
                    </div>
                    
                </div>
                
            </div>

            
            <div class="col-12 mt-2" v-if="funnels.length > 0 && view == 'list'" >
    
                <div class="w-100 position-relative" >
                    
                    <div class="col-12 pt-4 pb-4 border-bottom-gray border- font-size-14" v-for="(funnel, index) in funnels" :class="[{'border-top-gray': index == 0}]"  >
                        
                        <div class="row" >
                            <div class="col-12 col-md-3" > 
                                <h1 class="h3 font-900" > {{ funnel.name }}  </h1>
                                <div class="font-size-13 graymedium-color" > 
                                    Entry: 
                                    {{ returnLinkPath( funnel.steps[0].link ) }}
                                    <font-awesome-icon :icon="['fa', 'info-circle']" :id="`tooltip--funnel-${funnel.id}-step-${index}`"  />
                                    <b-tooltip :target="`tooltip--funnel-${funnel.id}-step-${index}`" placement="left" triggers="hover"  >
                                        Link: {{ funnel.steps[0].link }}
                                    </b-tooltip> 
                                </div>
                            </div>
                            
                            <div class="col-12  row" :class="[{'col-md-8': funnel.conversions.length > 0}, { 'col-md-9': funnel.conversions.length == 0 }]" > 
                                
                                <div class="col text-right border-left-gray" v-for="(step, index) in funnel.steps" >
                                    <h4 class="font-size-12 graymedium-color" > 
                                        {{ returnLinkPath( step.link ) }}
                                        <font-awesome-icon :icon="['fa', 'info-circle']" :id="`tooltip--funnel-${funnel.id}-step-${index}`"  />
                                        <b-tooltip :target="`tooltip--funnel-${funnel.id}-step-${index}`" placement="left" triggers="hover"  >
                                            Link: {{ step.link }}
                                        </b-tooltip>    
                                    </h4>
                                    <div> 
                                        <span class="h5 font-900 cursor-pointer" @click="fModalOpen( step.data )" > 
                                            <span class="" > 
                                                {{ step.count }} 
                                                <span class="font-size-12 font-500 " v-if="step.count != 1" > hits </span> 
                                                <span class="font-size-12 font-500 " v-if="step.count == 1" > hit </span>  
                                            </span>
                                            <span v-if="index > 0" class="Text-color--main border-left-gray pl-2 ml-2" > 
                                                <span class="font-size-12 font-500 " > CVR:  </span> 
                                                <span v-if="step.count > 0 && funnel.steps[0].count > 0" > {{ ( ( step.count /  funnel.steps[0].count ) * 100 ).toFixed(1) }}%   </span>
                                                <span v-else="" > 0%   </span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="col-12 col-md-1 text-right border-left-gray " v-if="funnel.conversions.length > 0"  > 
                                <h4 class="font-size-12 graymedium-color" > CONVERSIONS </h4>
                                <div> 
                                    <span class="h5 font-900 cursor-pointer" v-if="!funnel.loaded" > loading </span>
                                    <span v-else-if="funnel.loaded" class="h5 font-900 cursor-pointer" @click="fModalOpen( funnel.orders, 'orders' )" > 
                                        <span class="" > 
                                            {{ funnel.orders.length }} 
                                        </span>
                                        <span class="Text-color--main border-left-gray pl-2 ml-2" > 
                                            <span class="font-size-12 font-500 " > CVR:  </span> 
                                            <span v-if="funnel.orders.length > 0 && funnel.steps[0].count > 0" > {{ ( ( funnel.orders.length /  funnel.steps[0].count ) * 100 ).toFixed(1) }}%   </span>
                                            <span v-else="" > - </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                
            </div>
            
        </div>
        
        <modal :modalData="modalData" :modalState="modalState" :modalComponent="modalComponent" ></modal>
        
    </div><!-- end content template-padding -->

</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import moment from 'moment'
    
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
    
import helper from '@/helpers/helpers.js';
import modal from '@/components/modal.vue'    
import lineChart from '@/components/charts/lineChart_multiple.js'   
    
export default{
    name: "organizations",
    components:{
        modal,
        lineChart
    },
    data () {
        return {
            loaded : false,
            filter: '',
            rows: [],
            
            dataLoaded: false,
            modalData: null,
            modalState: false,
            modalComponent: null,
            
            startDate: null,
            endDate: null,
            formatDate: 'D MMM YYYY',
            period: [ "", "" ],
            shortcuts: [
                { 
                    text: 'Today', 
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('day').toDate();
                        let end = this.$moment(Date.now()).endOf('day').toDate();

                        let period = [ start, end ];
                        //console.log(period)
                        return period;
                    } 
                },
                {
                    text: 'Yesterday',
                    onClick: () => {
                        console.log( Date.now() )
                        //let start = this.$moment( ).subtract(1,'d').format( "YYYY-MM-DD 00:00:00" )
                        //let end = this.$moment( ).subtract(1,'d').endOf('day').format( "YYYY-MM-DD 00:00:00" )
                        
                        let start = this.$moment( ).subtract(1,'d').toDate();
                        let end = this.$moment( ).subtract(1,'d').endOf('day').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 7 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(7,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'weeks').startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'weeks').endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('month').toDate();
                        let end = this.$moment(Date.now()).endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 30 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(30,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'months').startOf('month').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'months').endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 3 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(3,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 6 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(6,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
            ],
            
            sales:[],
            funnels:[],
            selectedFunnel: null,
            
            view: 'list'
        }
    },
    beforeCreate: function (){
    
    },
    mounted: function(){
        
        //this.loaded = true;
        this.getFunnels()
        
    },
    computed: {
    },
    methods: {
        
        init_period(){
            
            let end = this.$moment(Date.now()).format('D MMM YYYY');
            //let start = this.$moment(Date.now()).subtract(30,'d').format('D MMM YYYY');
            let start = this.$moment(Date.now()).subtract(7,'d').format('D MMM YYYY');
            //let start = this.$moment(Date.now()).startOf('day').format('D MMM YYYY');

            this.period = [ start, end ];
            
            this.getData()
            
            
        },
        
        getData(){
            
            this.getSales()
            
        },
        
        getFunnels(){
            
            let OrgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+OrgID+'/funnels').orderBy('datetime', 'desc')
            
            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                item.loaded = false
                                item.steps.forEach((step)=>{
                                    step.loaded = false
                                    step.count = "?"
                                    step.color = "#"+Math.floor(Math.random()*16777215).toString(16);
                                })
                                
                                item.orders = []
                            
                                results.push(item);     
                                //console.log( item )

                                //results.sort((a, b) => b.datetime - a.datetime);
                            
                                this.funnels = results

                                return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        this.init_period()
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        
        getSales(){
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            let timezone = helper.getAccountTimezone()   
            let startUnix = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).unix()
            let endUnix = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).unix()
            

            var ref = firebase.firestore().collection('organizations/'+orgID+'/orders').where('datetime', '>=', startUnix).where( 'datetime', '<=', endUnix ).orderBy('datetime', 'asc')

            ref.get()
            .then((snapshot) => {
                if( !snapshot.empty ){
                    let results = []
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.id = doc.id;
                                
                                results.push(item)

                                this.sales = results
                                return results; 

                        })

                    )
                    .then(results => {           

                        //console.log( results )
                        //console.log( this.selectedFunnel.orders )
                        //this.filterTags = this.filterTags.filter((elem, index, self) => self.findIndex( (t) => {return (t.value === elem.value )}) === index)
                        
                        this.funnels.forEach((funnel)=>{
                            //this.getFunnelData(funnel)
                            let APPKEY = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
                            helper.getFunnelData( APPKEY, this.sales, this.period, funnel )
                        })
                        
                        return results;   

                    })
                }else{
                    console.log("no orders")
                }
            })

        },
        
        getFunnelData( funnel ){
            
            funnel.loaded = false
            
            funnel.chartData = []
            ////////////////////////////////////////////////////////////////

            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }

            let timezone = helper.getAccountTimezone()            
            let start = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            let offset = moment.tz(this.period[0], timezone ).format('Z')

            let signup = helper.getAccountSettings().datetime
            if( moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).unix() < signup ){
                //console.log( "Cannot request data for date prior to sign up" );
                start = moment.unix( signup ).tz("UTC").format( 'YYYY-MM-DD HH:mm:ss' )
            }

            //console.log(this.selectedFunnel)

            funnel.steps.forEach((step, index)=>{

                let searchPhrase = step.link

                step.count = 'loading'
                step.loaded = false

                //AXIOS
                return axios({ 
                    method: 'post',
                    //url: 'https://sql.theatlass.com/api/list.php?s='+searchPhrase,
                    url: 'https://sql.theatlass.com/api-v2/getList.php?s='+searchPhrase,
                    headers: { 
                        'Access-Control-Allow-Headers': '*', 
                        'Access-Control-Allow-Origin': '*',  
                        'Content-Type': 'application/json;' 
                    },
                    async: true,
                    data: { 
                        "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                        //"startDate":  moment.utc(this.period[0]).format('YYYY-MM-DD'),
                        "startDate":  start,
                        //"endDate":  moment.utc(this.period[1]).add(1, 'day').format('YYYY-MM-DD'),
                        "endDate":  end,
                        "tz_to": offset,
                        "searchPhrase": searchPhrase,
                        //"filters":  { key: "email", operator: "!=", value: "" }
                    } 
                })
                .then(resp => {
                    //console.log(resp)
                    if( resp.status == 200 ){
                        let response_data = resp.data.data.results
                        
                        //old version with count
                        /*
                        let interval = resp.data.data.interval
                        if( resp.data.data.unique ){
                            step.count = resp.data.data.unique.results[0].count   
                        }else{
                            step.count = 0
                        }
                        
                        step.data = resp.data.data.results
                        
                        let CHART_COLUMNS = []
                        let CHART_SERIES = []
                        
                        let format = 'YYYY-MM-DD'
                        if( interval == 'hours' ){
                            format = 'YYYY-MM-DD HH:mm:ss'
                        }
                        
                        response_data.forEach((d)=>{

                            if( 
                                this.$moment(d.day).format('YYYY-MM-DD') >= this.$moment(this.period[0]).format('YYYY-MM-DD') 
                               && this.$moment(d.day).format('YYYY-MM-DD') <= this.$moment(this.period[1]).format('YYYY-MM-DD') 
                               && this.$moment(d.day).format('YYYY-MM-DD HH:mm:ss') <= this.$moment().format('YYYY-MM-DD HH:mm:ss') 
                              ){

                                //data.data.push( d )
                                CHART_COLUMNS.push( d.day )
                                CHART_SERIES.push( d.count )
                                if( 'unique' in resp.data.data ){
                                    
                                }else{
                                    step.count += d.count
                                }
  
                            }

                        })
                        
                        //step.chartColumn = CHART_COLUMNS
                        //step.chartSeries = CHART_SERIES
                        
                        //addChartData
                        let chartData = {
                            name: step.link,
                            description: step.link,
                            data: CHART_SERIES,
                            columns: CHART_COLUMNS
                        }
                        
                        //console.log( chartData )
                        funnel.chartData.push( chartData )
                        */
        
                        //version 2 with list
                        step.data = response_data
                        step.count = step.data.length
                        
                    }else{
                        console.log("")
                    }                
                })
                .then(function(){
                    
                    step.loaded = true
                    //console.log( funnel.name + " - " + index + " - " + searchPhrase )
                    
                    let all_loaded = []
                    let isReady = funnel.steps.every(data=> data.loaded)
                    //console.log(isReady)
                    if( isReady ){ 
                        funnel.steps.forEach((step, index)=>{
                            
                            if( index > 0 ){
                                let curated = []
                                step.data.forEach((visitor)=>{
                                    
                                    funnel.steps.forEach((previousStep, previousIndex)=>{
                                        if( previousIndex < index && previousStep.data.length > 0 ){
                                            previousStep.data.forEach((previousVisitor)=>{
                                                if( visitor.leadID == previousVisitor.leadID && curated.find(el => el.leadID === visitor.leadID ) == undefined ){
                                                    //console.log(  visitor.sourceTag + " vs "+ previousVisitor.sourceTag )
                                                    if( visitor.sourceTag == null && previousVisitor.sourceTag != null ){
                                                        visitor.sourceTag = previousVisitor.sourceTag
                                                        visitor.sourceName = previousVisitor.sourceName
                                                    }
                                                    //console.log( visitor )
                                                    curated.push( visitor )
                                                }
                                            })
                                        }
                                            
                                    })
                                    

                                })
                                //step.data = curated 
                                step.count = step.data.length
                                
                            }
                            
                            let CHART_COLUMNS = []
                            let CHART_SERIES = []
                            let groupped = helper.groupSalesBy( step.data, start, end )
                            groupped.forEach((day)=>{
                                CHART_COLUMNS.push( day.date )
                                CHART_SERIES.push( day.count )
                            })

                            step.chartColumn = CHART_COLUMNS
                            step.chartSeries = CHART_SERIES

                            //addChartData
                            let chartData = {
                                name: step.link,
                                description: step.link,
                                data: CHART_SERIES,
                                columns: CHART_COLUMNS
                            }

                            //console.log( chartData )
                            funnel.chartData.push( chartData )
                            
                            
                        })
                        
                        if( funnel.conversions && funnel.conversions.length > 0 && this.sales.length > 0 ){
                                                      
                            let curatedOrders = []
                            this.sales.forEach((order)=>{
                                funnel.conversions.forEach((tag)=>{
                                    if( order.tag == tag ){
                                        curatedOrders.push( order )
                                    }else{
                                        order.orderItems.forEach((orderItem)=>{
                                            if( tag == orderItem.tag ){
                                                curatedOrders.push( order )
                                            }
                                        })
                                    }
                                })
                            })

                            //console.log( curatedOrders )
                            
                            let other = []
                            let final_curated = []
                            curatedOrders.forEach((order)=>{
                                if( funnel.steps[0].data.find(el => el.leadID === order.leadID ) != undefined ){
                                    final_curated.push( order )
                                }else{
                                    other.push(order)
                                }
                            })
                            
                            //console.log( other )
                            
                            //funnel.orders = final_curated
                            funnel.orders = curatedOrders
                            
                        }
                        funnel.loaded = true 
                    }


                }.bind(this))
                .catch(error => {

                    console.log(error)
                    this.getData()
                    /*
                    this.$toast.error({
                        title:'Error',
                        message:  'Error while fetching data. Please try hitting the request button again!'
                    })
                    */
                    
                }); //end axios 
                //AXIOS

            })
            //console.log(this.selectedFunnel)
            
            this.loaded = true;

            ////////////////////////////////////////////////////////////////
                
                
            
        },
        
        //Deprecated
        getList(step){
            
            this.$toast.warn({
                title:'Fetching',
                message:  'Fetching data, please wait...',
                position: 'top center',
            })
            
            ////////////////////////////////////////////////////////////////
                
                let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }

                let timezone = helper.getAccountTimezone()            
                let start = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
                let end = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
                let offset = moment.tz(this.period[0], timezone ).format('Z')

                let signup = helper.getAccountSettings().datetime
                if( moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).unix() < signup ){
                    //console.log( "Cannot request data for date prior to sign up" );
                    start = moment.unix( signup ).tz("UTC").format( 'YYYY-MM-DD HH:mm:ss' )
                }
                                    
                let searchPhrase = step.link

                //AXIOS
                axios({ 
                    method: 'post',
                    //url: 'https://sql.theatlass.com/api/list.php?s='+searchPhrase,
                    url: 'https://sql.theatlass.com/api-v2/getList.php?s='+searchPhrase,
                    headers: { 
                        'Access-Control-Allow-Headers': '*', 
                        'Access-Control-Allow-Origin': '*',  
                        'Content-Type': 'application/json;' 
                    },
                    data: { 
                        "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                        //"startDate":  moment.utc(day).format('YYYY-MM-DD 00:00:00'),
                        //"endDate":  moment.utc(day).format('YYYY-MM-DD 23:59:59'),
                        "startDate":  start,
                        "endDate":  end,
                        "searchPhrase": searchPhrase,
                        //"filters":  { key: "email", operator: "!=", value: "" }
                    } 
                })
                .then(resp => {
                    //console.log(resp)
                    if( resp.status == 200 ){
                        let response_data = resp.data.data.results

                        //console.log(response_data)
                        //PROCESS DATA
                        let data = []
                        response_data.forEach((lead)=>{
                            //lead.datetime = moment.utc(lead.date).unix()

                            if( lead.email == null ){
                                /*
                                let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
                                var ref = this.$firebase.firestore().collection('organizations/'+orgID+'/leads').doc( lead.leadID ).get()
                                        .then((doc) => {

                                            let item = {};                
                                            item = doc.data(); // will have 'todo.title'
                                            item.id = doc.id;

                                            //console.log(item)

                                            if( item.email ){
                                                lead.email = item.email
                                            }else{
                                                lead.email = "Unknown email ( visitor ) "
                                            }
                                            data.push( lead )

                                        })
                                */

                                lead.email = "Visitor"
                                data.push( lead )

                            }else{
                                data.push( lead )
                            }

                        })
                        this.fModalOpen( data )

                    }else{
                        console.log("")
                    }                
                })
                .then(function(){


                }.bind(this))

                .catch(error => {

                    console.log(error)
                    this.$toast.error({
                        title:'Error',
                        message:  'Error while fetching sources. Please reach out to us!'
                    })

                }); //end axios 
                //AXIOS
                                                        
                //console.log(this.selectedFunnel)
                this.loaded = true;
                
                ////////////////////////////////////////////////////////////////
            
        },
    
        get_list( day, searchPhrase ){
            /*
            this.$toast.info({
                title:'Info',
                message: 'Fetching data...'
            })
            */
            //this.get_data_list( day, searchPhrase )
            
            console.log(day)
            console.log(searchPhrase)
            
        },
        
        get_data_list( day, searchPhrase ){
            
            //this.chartLoaded = false
            
            //data = EITHER data_A or data_B
            
            //TEST DUMMY
            //let searchPhrase = 'muscleintelligence.com'
            
            //let searchPhrase = data.link
            if( searchPhrase.includes( 'https://' ) ){
                searchPhrase = searchPhrase.replace('https://','')
            }
            if( searchPhrase.includes( 'http://' ) ){
                searchPhrase = searchPhrase.replace('http://','')
            }

            let timezone = helper.getAccountTimezone()            
            
            let start = moment.tz(day, timezone ).startOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(day, timezone ).endOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            if( day.length == 19 ){
                start = moment.tz(day, timezone ).startOf('hour').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
                end = moment.tz(day, timezone ).endOf('hour').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            }
            
            if( day == 'all' ){
                start = moment.tz(this.period[0], timezone ).startOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
                end = moment.tz(this.period[1], timezone ).endOf('day').tz( 'UTC' ).format('YYYY-MM-DD HH:mm:ss')
            }
            
            //console.log( timezone + "| " + start + " - " + end )
            
            
            axios({ 
                method: 'post',
                //url: 'https://sql.theatlass.com/api/list.php?s='+searchPhrase,
                url: 'https://sql.theatlass.com/api-v2/getList.php?s='+searchPhrase,
                headers: { 
                    'Access-Control-Allow-Headers': '*', 
                    'Access-Control-Allow-Origin': '*',  
                    'Content-Type': 'application/json;' 
                },
                data: { 
                    "APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    //"startDate":  moment.utc(day).format('YYYY-MM-DD 00:00:00'),
                    //"endDate":  moment.utc(day).format('YYYY-MM-DD 23:59:59'),
                    "startDate":  start,
                    "endDate":  end,
                    "searchPhrase": searchPhrase,
                    //"filters":  { key: "email", operator: "!=", value: "" }
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let response_data = resp.data.data.results
                                      
                    //console.log(response_data)
                    //PROCESS DATA
                    let data = []
                    response_data.forEach((lead)=>{
                        //lead.datetime = moment.utc(lead.date).unix()
                        
                        if( lead.email == null ){
                            /*
                            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin, this.passed_organizationID )
                            var ref = this.$firebase.firestore().collection('organizations/'+orgID+'/leads').doc( lead.leadID ).get()
                                    .then((doc) => {
                                        
                                        let item = {};                
                                        item = doc.data(); // will have 'todo.title'
                                        item.id = doc.id;

                                        //console.log(item)

                                        if( item.email ){
                                            lead.email = item.email
                                        }else{
                                            lead.email = "Unknown email ( visitor ) "
                                        }
                                        data.push( lead )

                                    })
                            */
                            
                            lead.email = "Visitor"
                            data.push( lead )
                            
                        }else{
                            data.push( lead )
                        }
                        
                    })
                    this.fModalOpen( data )
                    
                }else{
                    console.log("")
                }                
            })
            .then(function(){

                
            }.bind(this))
            
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })

            }); //end axios 
            
        },
        //Deprecated
        
        
        fModalOpen( data, component = "engagement" ){
            
            this.modalData = data
            this.modalComponent = component
            this.modalState = true
        },
        
        refresh_chart( $event ){
            
            //console.log($event)
            this.rows = []
            if( this.period[0] == null || this.period[1] == null ){
                this.init_period()
            }else{
                
                this.getData()

            }
            
        },
        
        configureFunnels(){
            
            this.modalState = true;
            this.modalComponent = "funnels"
            this.modalData = this.funnels
            
        },
        
        randomColor( index ){
            
            let color = Math.floor(Math.random()*16777215).toString(16);
            console.log(color)
            return "#" + color
            
        },
        
        returnLinkPath( link ){
            
            let intruder = link.slice(link.length - 1)
            if( intruder == '/' ){
                link = link.slice(0,-1)
            }
            
            let paths = link.split('/')
            let path = paths[paths.length - 1]
                        
            if( path == '' ){
                return link
            }else{
                return "/" + paths[paths.length - 1]
            }
                
            
        }
        
    },
    computed:{
  
    },
}
</script>


<style lang="scss" >
    
    .tab-content{
        
    }
    
    .card-body{
        padding-left:0;
        padding-right:0;
    }

</style>


// WEBPACK FOOTER //
// src/templates/analyze/Funnels.vue